import { render, staticRenderFns } from "./TarifeItem.vue?vue&type=template&id=5d18da38&scoped=true"
import script from "./TarifeItem.vue?vue&type=script&lang=js"
export * from "./TarifeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d18da38",
  null
  
)

export default component.exports